(function () {
  'use strict';

  var TOC_LINKS = [
    { href: '#pbg-overview', label: 'Overview' },
    { href: '#pbg-features', label: 'Key Features' },
    { href: '#pbg-specs-table', label: 'Specifications' },
    { href: '#pbg-pros-cons', label: 'Pros & Cons' },
    { href: '#pbg-use-cases', label: 'Use Cases' },
    { href: '#pbg-parts', label: 'Parts & Accessories' },
    { href: '#pbg-maintenance', label: 'Maintenance' },
    { href: '#pbg-faq', label: 'FAQ' },
    { href: '#pbg-verdict', label: 'Final Verdict' },
    { href: '#pbg-deal', label: 'Shop Product' },
  ];

  var OVERVIEW_SKIP_HEADINGS = [
    'key features',
    'specifications',
    'key specifications',
    'pros',
    'cons',
    'pros & cons',
    'use cases',
    'best use cases',
    'parts',
    'accessories',
    'parts & accessories',
    'maintenance',
    'faq',
    'verdict',
    'final verdict',
    'buyer trust score',
    'rating breakdown',
    'buying checklist',
    'who should consider',
    'what job does it solve',
    'additional buyer guidance',
  ];

  var USE_CASE_ICONS = {
    Warehouses: '🏭',
    Manufacturing: '🏗',
    Schools: '🏫',
    'Schools and Churches': '🏫',
    'Small Warehouses': '🏭',
    'Retail Stores and Backrooms': '🛒',
    'Garages and Workshops': '🔧',
    'Property Management': '🏢',
    'Cleaning Contractors': '🚐',
    'Facility Entrances': '🚪',
    Garages: '🔧',
    'Retail backrooms': '🛒',
    Retail: '🛒',
    Offices: '🏢',
    Healthcare: '🏥',
    Contractors: '🚐',
    Churches: '⛪',
    'Industrial facilities': '🏗',
  };

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function computeTrustScore(guide) {
    if (guide.trustScore != null && !Number.isNaN(Number(guide.trustScore))) {
      return Math.max(5, Math.min(10, Math.round(Number(guide.trustScore) * 10) / 10));
    }

    var score = 5;
    if (guide.pros) score += Math.min(guide.pros.length * 0.35, 2);
    if (guide.cons) score -= Math.min(guide.cons.length * 0.2, 1.2);
    if (guide.specs && guide.specs.length >= 5) score += 0.8;
    if (guide.features && guide.features.length >= 4) score += 0.6;
    if (guide.maintenance && guide.maintenance.length >= 3) score += 0.5;
    if (guide.faq && guide.faq.length >= 3) score += 0.5;
    if (guide.productHandle) score += 0.4;
    return Math.max(5, Math.min(10, Math.round(score * 10) / 10));
  }

  function trustNote(score) {
    if (score >= 8.5) {
      return 'Excellent buyer confidence — strong specs, clear pros, and practical maintenance guidance.';
    }
    if (score >= 7) {
      return 'Good buyer confidence — solid fit for the right facility with normal trade-offs to plan for.';
    }
    return 'Moderate confidence — verify configuration, route fit, and support before purchasing.';
  }

  function verdictLabel(score) {
    if (score >= 8.5) return 'Highly Recommended';
    if (score >= 7) return 'Recommended';
    return 'Consider Carefully';
  }

  function buildVerdict(guide) {
    if (guide.verdict) return guide.verdict;
    var label = guide.categoryLabel || 'equipment';
    var use = guide.useCases && guide.useCases.slice(0, 3).join(', ');
    return (
      'Based on the specs, pros, cons, and maintenance notes in this guide, this ' +
      label.toLowerCase() +
      ' is a strong match for teams with recurring cleaning routes' +
      (use ? ' in settings like ' + use + '.' : '.') +
      ' Confirm storage, power, parts availability, and operator training before you buy.'
    );
  }

  function trimOverviewBody(body) {
    if (!body) return;
    body.querySelectorAll('p').forEach(function (p) {
      var text = p.textContent.trim();
      if (/^(secondary keywords|seo title|meta description|primary keyword|suggested url|category:|hero image)/i.test(text)) {
        p.style.display = 'none';
      }
    });
    var headings = body.querySelectorAll('h2, h3');
    headings.forEach(function (heading) {
      var text = heading.textContent.toLowerCase();
      var skip = OVERVIEW_SKIP_HEADINGS.some(function (needle) {
        return text.indexOf(needle) !== -1;
      });
      if (!skip) return;

      var node = heading;
      while (node) {
        var next = node.nextElementSibling;
        node.style.display = 'none';
        node = next && !/^H[23]$/.test(next.tagName) ? next : null;
        if (next && /^H[23]$/.test(next.tagName)) break;
      }
    });
  }

  function countWords(text) {
    return String(text || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean).length;
  }

  function heightForMinWords(body, minWords) {
    var blocks = [];
    var rte = body.querySelector('.rte');
    if (rte && rte.children.length) {
      blocks = Array.prototype.slice.call(rte.children);
    } else if (body.children.length) {
      blocks = Array.prototype.slice.call(body.children);
    } else {
      return body.scrollHeight;
    }

    if (countWords(body.innerText) <= minWords) {
      return body.scrollHeight;
    }

    var words = 0;
    var cutoff = blocks[blocks.length - 1];
    for (var i = 0; i < blocks.length; i++) {
      words += countWords(blocks[i].innerText);
      cutoff = blocks[i];
      if (words >= minWords) break;
    }

    var bodyRect = body.getBoundingClientRect();
    var cutRect = cutoff.getBoundingClientRect();
    return Math.ceil(cutRect.bottom - bodyRect.top + 20);
  }

  function initOverviewReadMore(root) {
    var wrap = root.querySelector('[data-pbg-overview-readmore]');
    if (!wrap || wrap.getAttribute('data-bound') === '1') return;

    var body = wrap.querySelector('[data-pbg-overview-body]');
    var btn = wrap.querySelector('[data-pbg-overview-readmore-btn]');
    if (!body || !btn) return;

    wrap.setAttribute('data-bound', '1');
    trimOverviewBody(body);

    var minWords = parseInt(wrap.getAttribute('data-tcb-bf-readmore-target-words') || wrap.getAttribute('data-tcb-bf-readmore-min-words') || '200', 10);
    var maxWords = parseInt(wrap.getAttribute('data-tcb-bf-readmore-max-words') || '300', 10);
    minWords = Math.min(Math.max(150, minWords), maxWords);
    var fullHeight = body.scrollHeight;
    var visibleHeight = heightForMinWords(body, minWords);

    if (fullHeight <= visibleHeight + 48) {
      btn.hidden = true;
      body.classList.remove('is-clamped');
      return;
    }

    body.style.maxHeight = visibleHeight + 'px';
    body.style.overflow = 'hidden';
    body.classList.add('is-clamped');
    wrap.classList.remove('is-expanded');

    btn.addEventListener('click', function () {
      var expanded = wrap.classList.toggle('is-expanded');
      body.style.maxHeight = expanded ? 'none' : visibleHeight + 'px';
      body.classList.toggle('is-clamped', !expanded);
      btn.textContent = expanded ? 'Read less' : 'Read more';
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function initHeroGallery(root) {
    var main = root.querySelector('[data-pbg-hero-main-image]');
    var thumbs = root.querySelector('[data-pbg-hero-thumbs]');
    if (!main || !thumbs) return;

    thumbs.querySelectorAll('[data-pbg-hero-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-pbg-hero-thumb');
        if (!src) return;
        main.src = src;
        thumbs.querySelectorAll('.tcb-pbg-hero__thumb').forEach(function (el) {
          el.classList.toggle('is-active', el === btn);
        });
      });
    });
  }

  function itemTitle(item) {
    return typeof item === 'object' ? item.title : item;
  }

  function itemText(item, fallback) {
    if (typeof item === 'object' && item.text) return item.text;
    return fallback || '';
  }

  function renderProConList(items, mark, markClass) {
    return items
      .map(function (item) {
        var title = itemTitle(item);
        var text = itemText(item, '');
        var body =
          text && text !== title
            ? '<strong>' + escapeHtml(title) + '</strong><span>' + escapeHtml(text) + '</span>'
            : escapeHtml(title);
        return (
          '<li><span class="tcb-pbg-pros-cons__mark ' +
          markClass +
          '" aria-hidden="true">' +
          mark +
          '</span><div>' +
          body +
          '</div></li>'
        );
      })
      .join('');
  }

  var MAINT_CARD_DEFAULTS = [
    {
      visual: 'sop',
      text: 'Create, manage, and enforce consistent standard operating procedures for every location.',
    },
    {
      visual: 'inventory',
      text: 'Maintain accurate inventory, set par levels, and get alerts before you run low.',
    },
    {
      visual: 'location',
      text: 'See where every machine is, its status, and maintenance history at a glance.',
    },
    {
      visual: 'calendar',
      text: 'Build preventive maintenance schedules and stay ahead of downtime with automated reminders.',
    },
  ];

  function maintIcon(type) {
    var icons = {
      sop:
        '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 3h6l3 3v15a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M9 7h6M9 11h6M9 15h4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
      inventory:
        '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7l8-4 8 4v10l-8 4-8-4V7z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M12 11v10M4 7l8 4 8-4" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>',
      location:
        '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s7-4.5 7-11a7 7 0 1 0-14 0c0 6.5 7 11 7 11z" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="10" r="2.5" fill="currentColor"/></svg>',
      calendar:
        '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M8 3v4M16 3v4M3 10h18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    };
    return icons[type] || icons.sop;
  }

  function maintVisual(type) {
    if (type === 'inventory') {
      return (
        '<div class="tcb-pbg-maint-mock tcb-pbg-maint-mock--inventory">' +
        '<div class="tcb-pbg-maint-mock__label">Parts Inventory</div>' +
        '<div class="tcb-pbg-maint-mock__table">' +
        '<div class="tcb-pbg-maint-mock__row tcb-pbg-maint-mock__row--head"><span>Part</span><span>On Hand</span><span>Par</span><span></span></div>' +
        '<div class="tcb-pbg-maint-mock__row"><span>Squeegee Blade</span><span>24</span><span>20</span><span class="tcb-pbg-maint-mock__dot tcb-pbg-maint-mock__dot--ok"></span></div>' +
        '<div class="tcb-pbg-maint-mock__row"><span>Brush Pad</span><span>8</span><span>15</span><span class="tcb-pbg-maint-mock__dot tcb-pbg-maint-mock__dot--warn"></span></div>' +
        '<div class="tcb-pbg-maint-mock__row"><span>Battery</span><span>2</span><span>6</span><span class="tcb-pbg-maint-mock__dot tcb-pbg-maint-mock__dot--low"></span></div>' +
        '</div></div>'
      );
    }
    if (type === 'location') {
      return (
        '<div class="tcb-pbg-maint-mock tcb-pbg-maint-mock--location">' +
        '<ul class="tcb-pbg-maint-mock__sites">' +
        '<li class="is-active">Dallas, TX <span>12 units</span></li>' +
        '<li>Houston, TX <span>9 units</span></li>' +
        '<li>Phoenix, AZ <span>7 units</span></li>' +
        '<li>Atlanta, GA <span>6 units</span></li>' +
        '</ul>' +
        '<div class="tcb-pbg-maint-mock__map">' +
        '<span class="tcb-pbg-maint-mock__pin" style="left:28%;top:42%"></span>' +
        '<span class="tcb-pbg-maint-mock__pin" style="left:52%;top:58%"></span>' +
        '<span class="tcb-pbg-maint-mock__pin is-active" style="left:68%;top:36%"></span>' +
        '<div class="tcb-pbg-maint-mock__tooltip">SC500-0045 · Phoenix, AZ · Operational</div>' +
        '</div></div>'
      );
    }
    if (type === 'calendar') {
      return (
        '<div class="tcb-pbg-maint-mock tcb-pbg-maint-mock--calendar">' +
        '<div class="tcb-pbg-maint-mock__label">PM Calendar · May 2025</div>' +
        '<div class="tcb-pbg-maint-mock__cal-row"><span>SC500-0021 PM</span><span class="tcb-pbg-maint-mock__bar" style="width:72%"></span></div>' +
        '<div class="tcb-pbg-maint-mock__cal-row"><span>RT50-0118 Filter</span><span class="tcb-pbg-maint-mock__bar tcb-pbg-maint-mock__bar--alt" style="width:55%"></span></div>' +
        '<div class="tcb-pbg-maint-mock__cal-row"><span>ECS-0044 Battery</span><span class="tcb-pbg-maint-mock__bar tcb-pbg-maint-mock__bar--warn" style="width:40%"></span></div>' +
        '</div>'
      );
    }
    return (
      '<div class="tcb-pbg-maint-mock tcb-pbg-maint-mock--sop">' +
      '<div class="tcb-pbg-maint-mock__label">SOP Library</div>' +
      '<div class="tcb-pbg-maint-mock__checklist">' +
      '<strong>Daily Walkaround Checklist</strong>' +
      '<ul><li>Inspect brushes &amp; pads</li><li>Check fluid levels</li><li>Test safety switches</li></ul>' +
      '</div></div>'
    );
  }

  function maintDashboardMock() {
    return (
      '<div class="tcb-pbg-maint-dash" aria-hidden="true">' +
      '<div class="tcb-pbg-maint-dash__screen">' +
      '<div class="tcb-pbg-maint-dash__title">Maintenance Overview</div>' +
      '<div class="tcb-pbg-maint-dash__stats">' +
      '<div><strong>128</strong><span>Units Online</span></div>' +
      '<div><strong>24</strong><span>PM Due This Week</span></div>' +
      '<div><strong>12</strong><span>Open Work Orders</span></div>' +
      '<div><strong>1,245</strong><span>Parts On Hand</span></div>' +
      '</div>' +
      '<div class="tcb-pbg-maint-dash__split">' +
      '<div class="tcb-pbg-maint-dash__list">' +
      '<strong>Upcoming PMs</strong>' +
      '<div class="tcb-pbg-maint-dash__item"><span>SC500-0021</span><span>May 12</span></div>' +
      '<div class="tcb-pbg-maint-dash__item"><span>RT50-0118</span><span>May 14</span></div>' +
      '<div class="tcb-pbg-maint-dash__item"><span>ECS-0044</span><span>May 16</span></div>' +
      '</div>' +
      '<div class="tcb-pbg-maint-dash__mini-cal">' +
      '<strong>PM Calendar</strong>' +
      '<div class="tcb-pbg-maint-dash__bar" style="width:80%"></div>' +
      '<div class="tcb-pbg-maint-dash__bar tcb-pbg-maint-dash__bar--alt" style="width:62%"></div>' +
      '<div class="tcb-pbg-maint-dash__bar tcb-pbg-maint-dash__bar--warn" style="width:48%"></div>' +
      '</div></div></div></div>'
    );
  }

  function normalizeMaintItem(item, index) {
    var def = MAINT_CARD_DEFAULTS[index] || MAINT_CARD_DEFAULTS[0];
    var title = itemTitle(item);
    return {
      title: title,
      text: itemText(item, def.text),
      visual: (typeof item === 'object' && item.visual) || def.visual,
    };
  }

  function renderMaintenanceWireframe(guide) {
    var hero = guide.maintenanceHero || {};
    var cta = guide.maintenanceCta || {};
    var items = (guide.maintenance || []).map(normalizeMaintItem);
    var ctaUrl = cta.url || guide.partsUrl || '/pages/parts-maintenance';

    return (
      '<div class="tcb-pbg-maint-wire">' +
      '<div class="tcb-pbg-maint-wire__hero">' +
      '<div class="tcb-pbg-maint-wire__copy">' +
      '<p class="tcb-pbg-maint-wire__kicker">' +
      escapeHtml(hero.kicker || 'Maintenance') +
      '</p>' +
      '<h2 class="tcb-pbg-maint-wire__heading">' +
      escapeHtml(hero.heading || 'Simplify Maintenance. Maximize Uptime.') +
      '</h2>' +
      '<p class="tcb-pbg-maint-wire__lede">' +
      escapeHtml(
        hero.lede ||
          'Centralize processes, inventory, and schedules to keep your equipment running efficiently across every location.'
      ) +
      '</p></div>' +
      maintDashboardMock() +
      '</div>' +
      '<div class="tcb-pbg-maint-wire__cards">' +
      items
        .map(function (item, index) {
          return (
            '<article class="tcb-pbg-maint-card">' +
            '<span class="tcb-pbg-maint-card__num">' +
            String(index + 1) +
            '</span>' +
            '<div class="tcb-pbg-maint-card__icon">' +
            maintIcon(item.visual) +
            '</div>' +
            '<h3>' +
            escapeHtml(item.title) +
            '</h3>' +
            '<p>' +
            escapeHtml(item.text) +
            '</p>' +
            maintVisual(item.visual) +
            '</article>'
          );
        })
        .join('') +
      '</div>' +
      '<div class="tcb-pbg-maint-wire__cta">' +
      '<div class="tcb-pbg-maint-wire__cta-icon" aria-hidden="true">' +
      '<svg width="28" height="28" viewBox="0 0 24 24"><path d="M12 3l7 3v6c0 4.4-3 8.5-7 9-4-.5-7-4.6-7-9V6l7-3z" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M9 12l2 2 4-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</div>' +
      '<div class="tcb-pbg-maint-wire__cta-copy">' +
      '<strong>' +
      escapeHtml(cta.heading || 'Fewer Breakdowns. Lower Costs. Longer Equipment Life.') +
      '</strong>' +
      '<span>' +
      escapeHtml(
        cta.text ||
          'A proactive maintenance program keeps your fleet reliable and your operations moving.'
      ) +
      '</span></div>' +
      '<a class="tcb-pbg-maint-wire__cta-btn" href="' +
      escapeHtml(ctaUrl) +
      '">' +
      escapeHtml(cta.label || 'Learn More') +
      '</a></div></div>'
    );
  }

  function renderMaintenance(guide) {
    if (guide.maintenanceSections && guide.maintenanceSections.length) {
      return guide.maintenanceSections
        .map(function (section) {
          if (section.items && section.items.length) {
            return (
              '<div class="tcb-pbg-maint-group">' +
              '<h3>' +
              escapeHtml(section.title) +
              '</h3><ul class="tcb-pbg-maint-list">' +
              section.items
                .map(function (item) {
                  return (
                    '<li><strong>' +
                    escapeHtml(itemTitle(item)) +
                    '</strong><span>' +
                    escapeHtml(itemText(item)) +
                    '</span></li>'
                  );
                })
                .join('') +
              '</ul></div>'
            );
          }
          return (
            '<div class="tcb-pbg-maint-group tcb-pbg-maint-group--note">' +
            '<h3>' +
            escapeHtml(section.title) +
            '</h3><p>' +
            escapeHtml(section.text || '') +
            '</p></div>'
          );
        })
        .join('');
    }

    if (!guide.maintenance) return '';
    return renderMaintenanceWireframe(guide);
  }

  function defaultParts(guide) {
    var partsUrl = guide.partsUrl || guide.collection || '/collections/shop-all-parts';
    if (guide.parts && guide.parts.length) return guide.parts;

    return [
      { title: 'Main brush / broom', shopUrl: partsUrl + (partsUrl.indexOf('?') >= 0 ? '&' : '?') + 'q=brush' },
      { title: 'Filters & bags', shopUrl: partsUrl + (partsUrl.indexOf('?') >= 0 ? '&' : '?') + 'q=filter' },
      { title: 'Wear items & accessories', shopUrl: partsUrl },
    ];
  }

  function renderGuide(root, guide) {
    if (!guide) return;

    var catLabel = root.querySelector('[data-pbg-category-label]');
    var catCrumb = root.querySelector('[data-pbg-category-crumb]');
    if (guide.categoryLabel) {
      if (catLabel) catLabel.textContent = guide.categoryLabel + ' Buying Guide';
      if (catCrumb) catCrumb.textContent = guide.categoryLabel;
    }

    var readMinutes = root.querySelector('[data-pbg-read-minutes]');
    if (readMinutes && guide.readMinutes) {
      readMinutes.textContent = guide.readMinutes + ' min read';
    }

    var trustPoints = root.querySelector('[data-pbg-trust-points]');
    if (trustPoints && guide.trustPoints && guide.trustPoints.length) {
      trustPoints.innerHTML = guide.trustPoints
        .map(function (point) {
          return '<span>' + escapeHtml(point) + '</span>';
        })
        .join('');
    }

    var statSource = guide.heroStats && guide.heroStats.length ? guide.heroStats : guide.specs;

    var specsGrid = root.querySelector('[data-pbg-specs]');
    if (specsGrid && statSource) {
      specsGrid.innerHTML = statSource
        .slice(0, 6)
        .map(function (s) {
          return (
            '<div class="tcb-pbg-specs__item"><strong>' +
            escapeHtml(s.label) +
            '</strong><span>' +
            escapeHtml(s.value) +
            '</span></div>'
          );
        })
        .join('');
    }

    var overviewStats = root.querySelector('[data-pbg-overview-stats]');
    if (overviewStats && statSource) {
      overviewStats.innerHTML = statSource
        .slice(0, 4)
        .map(function (s) {
          return (
            '<div class="tcb-pbg-overview-stat"><strong>' +
            escapeHtml(s.value) +
            '</strong><span>' +
            escapeHtml(s.label) +
            '</span></div>'
          );
        })
        .join('');
    }

    var sidebarSpecs = root.querySelector('[data-pbg-sidebar-specs]');
    if (sidebarSpecs && statSource) {
      sidebarSpecs.innerHTML = statSource
        .slice(0, 5)
        .map(function (s) {
          return (
            '<li><strong>' +
            escapeHtml(s.label) +
            ':</strong> ' +
            escapeHtml(s.value) +
            '</li>'
          );
        })
        .join('');
    }

    var features = root.querySelector('[data-pbg-features]');
    if (features && guide.features) {
      features.innerHTML = guide.features
        .map(function (f, index) {
          var title = typeof f === 'object' ? f.title : f;
          var text = typeof f === 'object' ? f.text : 'Built for commercial routes that need reliable daily performance.';
          return (
            '<div class="tcb-pbg-feature-card">' +
            '<span class="tcb-pbg-feature-card__icon" aria-hidden="true">' +
            String(index + 1) +
            '</span>' +
            '<div><strong>' +
            escapeHtml(title) +
            '</strong><p>' +
            escapeHtml(text) +
            '</p></div></div>'
          );
        })
        .join('');
    }

    var specTable = root.querySelector('[data-pbg-spec-table]');
    if (specTable && guide.specs) {
      specTable.innerHTML = guide.specs
        .map(function (s) {
          return '<tr><td>' + escapeHtml(s.label) + '</td><td>' + escapeHtml(s.value) + '</td></tr>';
        })
        .join('');
    }

    var pros = root.querySelector('[data-pbg-pros]');
    var sidebarPros = root.querySelector('[data-pbg-sidebar-pros]');
    if (guide.pros) {
      var prosHtml = renderProConList(guide.pros, '✓', 'tcb-pbg-pros-cons__mark--pro');
      if (pros) pros.innerHTML = prosHtml;
      if (sidebarPros) {
        sidebarPros.innerHTML = guide.pros
          .map(function (p) {
            return '<li>' + escapeHtml(itemTitle(p)) + '</li>';
          })
          .join('');
      }
    }

    var cons = root.querySelector('[data-pbg-cons]');
    if (cons && guide.cons) {
      cons.innerHTML = renderProConList(guide.cons, '✕', 'tcb-pbg-pros-cons__mark--con');
    }

    var useCases = root.querySelector('[data-pbg-use-cases]');
    if (useCases && guide.useCases) {
      useCases.innerHTML = guide.useCases
        .map(function (u) {
          var title = itemTitle(u);
          var text = itemText(u, 'Strong fit when this environment matches your daily route and debris profile.');
          return (
            '<div class="tcb-pbg-use-case">' +
            '<span class="tcb-pbg-use-case__icon" aria-hidden="true">' +
            escapeHtml(USE_CASE_ICONS[title] || USE_CASE_ICONS[title.split(' ')[0]] || '✓') +
            '</span>' +
            '<strong>' +
            escapeHtml(title) +
            '</strong>' +
            '<p>' +
            escapeHtml(text) +
            '</p></div>'
          );
        })
        .join('');
    }

    var partsAll = root.querySelector('[data-pbg-parts-all]');
    var partsUrl = guide.partsUrl || guide.collection || '/collections/shop-all-parts';
    if (partsAll) partsAll.href = partsUrl;

    var partsIntro = root.querySelector('[data-pbg-parts-intro]');
    if (partsIntro && guide.partsIntro) {
      partsIntro.textContent = guide.partsIntro;
      partsIntro.hidden = false;
    }

    var parts = root.querySelector('[data-pbg-parts]');
    if (parts) {
      parts.innerHTML = defaultParts(guide)
        .map(function (part) {
          return (
            '<a class="tcb-pbg-part-card" href="' +
            escapeHtml(part.shopUrl || partsUrl) +
            '"><span class="tcb-pbg-part-card__icon" aria-hidden="true">⚙</span>' +
            '<strong>' +
            escapeHtml(part.title) +
            '</strong>' +
            (part.text ? '<p class="tcb-pbg-part-card__text">' + escapeHtml(part.text) + '</p>' : '') +
            (part.sku ? '<small>Order #' + escapeHtml(part.sku) + '</small>' : '') +
            (part.price ? '<span class="tcb-pbg-part-card__price">' + escapeHtml(part.price) + '</span>' : '') +
            '<span class="tcb-pbg-part-card__cta">Add to Quote</span></a>'
          );
        })
        .join('');
    }

    var maintenance = root.querySelector('[data-pbg-maintenance]');
    if (maintenance && (guide.maintenanceSections || guide.maintenance)) {
      maintenance.innerHTML = renderMaintenance(guide);
      maintenance.className = 'tcb-pbg-maint';
      if (guide.maintenance && !guide.maintenanceSections) {
        maintenance.classList.add('tcb-pbg-maint--wire');
      }
    }

    var faq = root.querySelector('[data-pbg-faq]');
    if (faq && guide.faq) {
      faq.innerHTML = guide.faq
        .map(function (item) {
          return (
            '<details><summary>' +
            escapeHtml(item.q) +
            '</summary><p>' +
            escapeHtml(item.a) +
            '</p></details>'
          );
        })
        .join('');
    }

    var scoreOutOf5 =
      guide.buyerRating != null && !Number.isNaN(Number(guide.buyerRating))
        ? Math.round(Number(guide.buyerRating) * 10) / 10
        : Math.round((computeTrustScore(guide) / 2) * 10) / 10;
    var verdict = root.querySelector('[data-pbg-verdict]');
    if (verdict) {
      var verdictHtml = '<p>' + escapeHtml(buildVerdict(guide)) + '</p>';
      if (guide.bestFor) {
        verdictHtml += '<p><strong>Best for:</strong> ' + escapeHtml(guide.bestFor) + '</p>';
      }
      if (guide.skipIf) {
        verdictHtml += '<p><strong>Skip it if:</strong> ' + escapeHtml(guide.skipIf) + '</p>';
      }
      verdict.innerHTML = verdictHtml;
    }

    var verdictLabelEl = root.querySelector('[data-pbg-verdict-label]');
    var verdictHeading = root.querySelector('[data-pbg-verdict-heading]');
    var label = guide.verdictLabel || verdictLabel(scoreOutOf5 * 2);
    if (verdictLabelEl) verdictLabelEl.textContent = label;
    if (verdictHeading) verdictHeading.textContent = label;

    var verdictHighlights = root.querySelector('[data-pbg-verdict-highlights]');
    var highlightSource = guide.verdictHighlights || (guide.pros ? guide.pros.slice(0, 3).map(itemTitle) : []);
    if (verdictHighlights && highlightSource.length) {
      verdictHighlights.innerHTML = highlightSource
        .map(function (item) {
          return '<li>' + escapeHtml(item) + '</li>';
        })
        .join('');
    }

    var ratingBreakdown = root.querySelector('[data-pbg-rating-breakdown]');
    if (ratingBreakdown && guide.ratingBreakdown) {
      ratingBreakdown.innerHTML =
        '<table class="tcb-pbg-rating-table"><tbody>' +
        guide.ratingBreakdown
          .map(function (row) {
            return (
              '<tr><td>' +
              escapeHtml(row.label) +
              '</td><td>' +
              escapeHtml(String(row.score)) +
              ' / 5</td></tr>'
            );
          })
          .join('') +
        '</tbody></table>';
    }

    var scoreEl = root.querySelector('[data-pbg-trust-score]');
    var starsEl = root.querySelector('[data-pbg-trust-stars]');
    if (scoreEl) scoreEl.textContent = scoreOutOf5.toFixed(1);
    if (starsEl) {
      var stars = Math.max(1, Math.min(5, Math.round(scoreOutOf5)));
      starsEl.textContent = '★'.repeat(stars) + '☆'.repeat(5 - stars);
    }
  }

  function initToc(root) {
    var links = root.querySelectorAll('.tcb-pbg-toc__inner a, .tcb-pbg-sidebar__toc a');
    if (!links.length) return;

    function onScroll() {
      var active = null;
      links.forEach(function (link) {
        var id = link.getAttribute('href');
        if (!id || id.charAt(0) !== '#') return;
        var el = root.querySelector(id);
        if (!el) return;
        if (el.getBoundingClientRect().top <= 120) active = link;
      });
      links.forEach(function (link) {
        link.classList.toggle('is-active', link === active);
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function cartRoute(path) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return base.replace(/\/$/, '') + path;
  }

  function refreshCartCount() {
    fetch(cartRoute('/cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number') return;
        document.querySelectorAll('.header__cart-count, [data-tcb-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (el.hasAttribute('data-tcb-cart-count')) el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  function initAddToCart(root) {
    root.querySelectorAll('[data-pbg-add-to-cart]').forEach(function (form) {
      if (form.getAttribute('data-pbg-cart-bound') === '1') return;
      form.setAttribute('data-pbg-cart-bound', '1');
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        var resetLabel = btn ? btn.textContent.trim() : 'Add to Cart';
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Adding…';
        }
        fetch(cartRoute('/cart/add.js'), {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        })
          .then(function (r) {
            return r.json().then(function (data) {
              return { ok: r.ok, data: data };
            });
          })
          .then(function (res) {
            if (!res.ok) {
              if (btn) {
                btn.textContent = 'Unavailable';
                setTimeout(function () {
                  btn.disabled = false;
                  btn.textContent = resetLabel;
                }, 1800);
              }
              return;
            }
            if (btn) {
              btn.textContent = 'Added ✓';
              setTimeout(function () {
                btn.disabled = false;
                btn.textContent = resetLabel;
              }, 1600);
            }
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } })
            );
            document.dispatchEvent(new CustomEvent('tcb:cart-updated'));
            refreshCartCount();
          })
          .catch(function () {
            if (btn) {
              btn.disabled = false;
              btn.textContent = resetLabel;
            }
            form.submit();
          });
      });
    });
  }

  function initProductFallback(root, guide) {
    if (!guide || !guide.productHandle) return;
    var handle = guide.productHandle;
    var current = root.getAttribute('data-pbg-resolved-handle');
    if (current === handle) return;

    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('product missing');
        return r.json();
      })
      .then(function (product) {
        var variant = product.variants && product.variants[0];
        if (!variant) return;
        root.setAttribute('data-pbg-resolved-handle', handle);

        root.querySelectorAll('[data-pbg-product-link]').forEach(function (link) {
          link.setAttribute('href', product.url);
        });

        root.querySelectorAll('[data-pbg-product-title]').forEach(function (el) {
          el.textContent = product.title;
        });

        root.querySelectorAll('[data-pbg-product-price]').forEach(function (el) {
          el.textContent = '$' + (variant.price / 100).toFixed(2);
        });

        root.querySelectorAll('[data-pbg-add-to-cart]').forEach(function (form) {
          var input = form.querySelector('input[name="id"]');
          if (input) input.value = String(variant.id);
          form.hidden = !variant.available;
        });

        initAddToCart(root);

        if (product.featured_image) {
          root.querySelectorAll('[data-pbg-product-image]').forEach(function (img) {
            img.src = product.featured_image;
            img.alt = product.title;
          });

          var main = root.querySelector('[data-pbg-hero-main-image]');
          var thumbs = root.querySelector('[data-pbg-hero-thumbs]');
          if (main && thumbs && !thumbs.querySelector('[data-pbg-hero-thumb="' + product.featured_image + '"]')) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'tcb-pbg-hero__thumb';
            btn.setAttribute('data-pbg-hero-thumb', product.featured_image);
            btn.setAttribute('aria-label', 'Product image');
            btn.innerHTML =
              '<img src="' +
              escapeHtml(product.featured_image.replace(/(\.jpg|\.png|\.webp)/, '_160x$1')) +
              '" alt="" width="80" height="60" loading="lazy">';
            thumbs.appendChild(btn);
            initHeroGallery(root);
          }
        }
      })
      .catch(function () {
        /* ponytail: Liquid collection fallback still renders if product.js fails */
      });
  }

  function initSidebarToc(root) {
    var nav = root.querySelector('[data-pbg-sidebar-toc]');
    if (!nav) return;
    nav.innerHTML = TOC_LINKS.map(function (item) {
      return '<a href="' + item.href + '">' + escapeHtml(item.label) + '</a>';
    }).join('');
  }

  function resolveGuideHandle(data, handle, root) {
    if (!handle && root) {
      handle = root.getAttribute('data-pbg-guide-handle') || '';
    }
    if (!handle) return '';
    if (data[handle]) return handle;
    var short = String(handle).split('/').pop();
    if (data[short]) return short;
    return short;
  }

  function init() {
    var root = document.querySelector('[data-tcb-product-buying-guide]');
    if (!root) return;

    initSidebarToc(root);
    initToc(root);
    initHeroGallery(root);
    initOverviewReadMore(root);
    initAddToCart(root);

    var handle = resolveGuideHandle({}, window.TCB_MACHINE_GUIDE_HANDLE, root);
    var url = window.TCB_MACHINE_GUIDES_URL;
    if (!handle || !url) return;

    fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        handle = resolveGuideHandle(data, window.TCB_MACHINE_GUIDE_HANDLE, root);
        var guide = data[handle];
        if (!guide) return;
        renderGuide(root, guide);
        initProductFallback(root, guide);
      })
      .catch(function () {
        /* ponytail: static article content still renders if JSON fetch fails */
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
